import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Security\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "Please note a start date cannot be confirmed unless the preliminary checks are complete and we may need to return the\n                ATR to you whilst the checks are being completed.\n            ", -1);
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["innerHTML"];
import { Input } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'sercurityForm',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const security_role = Input('Is this a Security Role?', 'security_role', 'text', props.disableForm, props.formData.securityRole);
        const sia = Input('Is a Security Industry Authority Licence (SIA) Required?', 'sia', 'text', props.disableForm, props.formData.securitySIA);
        const security_check = Input('Is a Security Check (BS7858) Required?', 'security_check', 'text', props.disableForm, props.formData.securityCheck);
        const preliminary_check = Input('Have the preliminary checks been carried out for BS7858 Security Clearance?', 'preliminary_check', 'text', props.disableForm, props.formData.securityPreliminary);
        const edf_only = Input('Is a Security Baseline Standard Verification Record (BSVR) Check Required? (EDF Only)?', 'edf_only', 'text', props.disableForm, props.formData.securityBSVR);
        const clearance_required = Input('Is Government Level Clearance Required?', 'clearance_required', 'text', props.disableForm, props.formData.securityGovernment);
        const dwp_only = Input('Does employee work at a DWP site (therefore BPSS Clearance is always a requirement)?', 'dwp_only', 'text', props.disableForm, props.formData.securityDWP);
        const mobile_patrol = Input('Is this a Security Role Carrying Out Mobile Patrols?', 'mobile_patrol', 'text', props.disableForm, props.formData.securityMobile);
        const start_before = Input('Can Employee Start Before Checks Complete?', 'mobile_patrol', 'text', props.disableForm, props.formData.securityBefore);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(security_role) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(sia) }, null, 8, _hoisted_6),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(security_check) }, null, 8, _hoisted_7),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(preliminary_check) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _hoisted_9,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(edf_only) }, null, 8, _hoisted_10),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(clearance_required) }, null, 8, _hoisted_11),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(dwp_only) }, null, 8, _hoisted_12),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(mobile_patrol) }, null, 8, _hoisted_13),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(start_before) }, null, 8, _hoisted_14)
                    ])
                ])
            ]));
        };
    }
});
